import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Button, Modal } from "src/components";
import { RootState } from "src/context/store";
import { useToast } from "src/hooks/useToast";
import { addCluster, editCluster } from "src/services/company-api";
import * as yup from "yup";
import GenericForm from "../counter-master/form.component";

interface IAddEditCluster {
  setShowAddForm: any;
  refetch: any;
}


//M10-9403
const schema = yup.object().shape({
  cluster_name: yup.string().required("Cluster Name is required"),
  company_code: yup.object().required("Company Code is required"),
});

const AddEditCluster = ({ setShowAddForm, refetch }: IAddEditCluster) => {
  const [loading, setLoading] = useState(false);

  const { toast } = useToast();

  const { addEditFormData, isEdit, companyList } = useSelector((state: RootState) => state.cluster);
  const formFields: any[] = [
    {
      id: "cluster_name",
      type: "text",
      label: "Cluster Name",
      placeholder: "Enter Cluster Name",
      keyofForm: "cluster_name",
    },
    {
      id: "company_code",
      type: "autocomplete",
      label: "Company Name",
      placeholder: "Enter Company Name",
      keyofForm: "company_code",
      suggestionList: companyList,
      displayKey: "label",
    },

  ];

  const smartFormInstance = useForm({
    mode: "onBlur",
    defaultValues: structuredClone(
      isEdit
        ? structuredClone(addEditFormData)
        : {
          cluster_name: "",
          company_code: ""
        }
    ),
    resolver: yupResolver(schema) as any,
  });

  const onSubmit = async (data: any) => {
    if (loading) return;
    try {
      const payload = {
        ...data,
        active_status: "Y",
        cluster_name: data?.cluster_name,
        company_code: data?.company_code?.value
      };
      if (isEdit) {
        payload.uid = addEditFormData.uid;
      }
      const res = isEdit ? await editCluster(payload, payload?.company_code) : await addCluster(payload,payload?.company_code);
      if (res.status === 200) {
        toast({
          title: "Success",
          description: isEdit ? "Cluster edited successfully" : "Cluster added successfully",
          variant: "default",
        });
        setTimeout(() => {
          refetch();
          setShowAddForm(false);
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "Something went wrong",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isHeader={true}
      onBack={() => {
        setShowAddForm(false);
      }}
      title={isEdit ? "Edit Cluster" : "Select Cluster"}
      isOpen={true}
      onCloseModal={() => {
        setShowAddForm(false);
      }}
    >
      <GenericForm
        formFields={formFields}
        onFormSubmit={() => { }}
        defaultValues={{}}
        formInstance={smartFormInstance}
      >
        <footer className="flex justify-end gap-3 px-5 pb-5">
          <Button onClick={() => setShowAddForm(false)} className="border">
            Cancel
          </Button>
          <Button
            isLoading={loading}
            loaderSize="small"
            disabled={loading}
            onClick={() => {
              setLoading(true);
              smartFormInstance.handleSubmit(onSubmit, () => {
                setLoading(false);
              })();
            }}
            className="text-white bg-primary"
          >
            {isEdit ? "Edit "  : "Add "}
            Cluster
          </Button>
        </footer>
      </GenericForm>
    </Modal>
  );
};

export default AddEditCluster;
